import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { Router } from '@angular/router';
import { Color, Product, ProductVariant, Size } from '@interfaces/interfaces';
import { BffApiService } from '@shared/bff-api.service';
import { DeleteItemComponent } from '@shared/delete-item/delete-item.component';
import { ProductListService } from '@shared/service/product-list.service';
import { SnackBarService } from 'src/app/shared/service/snack-bar.service';

@Component({
  selector: 'app-store',
  templateUrl: './store.component.html',
  styleUrls: ['./store.component.scss'],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, MatTableModule],
})
export class StoreComponent implements OnInit {
  colors: Color[] = [];
  sizes: Size[] = [];
  productList: Product[] = [];
  dataProductsList = new MatTableDataSource();
  displayedColumns: string[] = ['name', 'categories', 'brand', 'actions'];
  isAddVariant: boolean = false;
  isTableExpanded = false;
  productVariantForm: FormGroup;
  editVariantInProgress: boolean = false;

  constructor(
    private router: Router,
    public dialog: MatDialog,
    private fb: FormBuilder,
    private snack: SnackBarService,
    private bff: BffApiService,
    private prodService: ProductListService
  ) {
    this.productVariantForm = this.fb.group({
      photos: [[], Validators.required],
      color: [[], Validators.required],
      sizes: [],
      initialQuantities: [[]],
      isNew: [false],
    });
    const skeletonProduct = {
      name: 'Loading...',
      category: { name: 'Loading...' },
      brand: 'Loading...',
      description: 'Loading...',
      variants: [],
      isLoading: true,
    };
    for (let i = 0; i < 10; i++) this.dataProductsList.data.push(skeletonProduct);
  }

  ngOnInit() {
    this.loadProducts();
  }

  loadProducts(page: number = 1) {
    this.bff.getProducts(undefined, page).subscribe((response) => {
      this.dataProductsList.data = response.data;
    });
  }

  onPaginate(link: any) {
    if (link.url) {
      const page = new URL(link.url).searchParams.get('page');
      this.loadProducts(Number(page));
    }
  }

  // Toggle Rows
  toggleTableRows() {
    this.isTableExpanded = !this.isTableExpanded;

    this.dataProductsList.data.forEach((row: any) => {
      row.isExpanded = this.isTableExpanded;
    });
  }

  editVariant(product: Product) {
    if (this.editVariantInProgress == true) return;
    this.editVariantInProgress = true;
    this.prodService.changeProduct(product);
    this.router.navigate(['/dashboard/edit-product/' + product.id]);
  }

  toggleVariante() {
    this.isAddVariant = !this.isAddVariant;
  }

  toggleEdit(productVariant: ProductVariant) {
    productVariant.isEdit = !productVariant.isEdit;
  }

  filterProduct() {
    // TODO filter products
  }

  addItemInList(product_id: string | number, values: any, id: any) {
    const sizeVariant: Size[] = [];
    sizeVariant.push(this.sizes.find((c) => c.name === values.size)!);
    this.productList
      .find((product) => product.id === product_id)
      ?.variants.push({
        id: -9999999,
        color: this.colors.find((c) => c.name === values.color)!,
        sizes: sizeVariant,
        quantity: values.quantity,
      });
  }

  deleteItem(item: any) {
    this.dialog
      .open(DeleteItemComponent, {
        data: item,
      })
      .afterClosed()
      .subscribe((result) => {
        if (result == false) {
        } else if (result == true) {
        }
        console.log(`${result}`);
      });
  }
}
